module.exports = __webpack_public_path__ + "img/icon-success.b1900ec3.png";